// ABOUTME: Index of the assigned owner/dealership/client/market references of the search result nodes, by node id.
// ABOUTME: The data-table flattens each node into its own row shape and drops these fields, so cells read them here.

export type AssignedRef = { id: string; code: string; listName?: string | null };

export const ASSIGNED_REF_FIELDS = [
    'assignedOwner',
    'assignedDealership',
    'assignedClient',
    'assignedMarket',
] as const;

export type AssignedRefField = (typeof ASSIGNED_REF_FIELDS)[number];

export type AssignedRefs = Partial<Record<AssignedRefField, AssignedRef | null>>;

type SearchEdge = { node?: ({ id?: string | null } & AssignedRefs) | null } | null | undefined;

/** node id → its assigned references, for the nodes of one search page. */
export const indexAssignedRefs = (edges: SearchEdge[]): Map<string, AssignedRefs> =>
    new Map(
        edges
            .map(edge => edge?.node)
            .filter((node): node is NonNullable<typeof node> & { id: string } => !!node?.id)
            .map(node => [
                node.id,
                Object.fromEntries(
                    ASSIGNED_REF_FIELDS.map(field => [field, node[field] ?? null]),
                ) as AssignedRefs,
            ]),
    );

/** The reference of a row: from the index (by row id), else from the row itself when it kept it. */
export const resolveAssignedRef = (
    row: Record<string, unknown> | undefined,
    field: AssignedRefField,
    index: Map<string, AssignedRefs> | undefined,
): AssignedRef | null => {
    const id = typeof row?.id === 'string' ? row.id : undefined;
    const fromIndex = id ? index?.get(id)?.[field] : undefined;
    if (fromIndex) return fromIndex;
    return (row?.[field] as AssignedRef | null | undefined) ?? null;
};
